import React, { useState } from 'react';
import { Modal, Box, Button, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import '../translations.js'
import './confirmationModal.css'

// note (optional): one line under the question, e.g. what stops working after the delete
const ConfirmationModal = ({ open, onClose, onConfirm, itemName, note, requireTextConfirmation = false }) => {
  const [confirmationText, setConfirmationText] = useState("");
  const { t } = useTranslation();
  const resolvedItemName = itemName ?? t('confirm_default_item_name');
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleConfirm = () => {
    if (requireTextConfirmation && confirmationText !== "delete") {
      return;
    }
    onConfirm();
    setConfirmationText("");
    onClose();
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: 'white',
          borderRadius: '10px',
          boxShadow: 24,
          p: 4,
          padding: isMobile ? '20px': '30px',
          width: isMobile ? '80%' : '90%',
          maxWidth: 400,
        }}
      >
        <h3 style={{ marginTop: 0, marginBottom: '20px' }}>{t('confirm_deletion')}</h3>
        <p>{t('are_you_sure_delete')} <strong>{resolvedItemName}</strong>?</p>
        {note && <p className="confirmation-note">{note}</p>}
        {requireTextConfirmation && (
          <>
            <p>{t('please_type_delete_to_confirm')}:</p>
            <TextField
              fullWidth
              value={confirmationText}
              onChange={(e) => setConfirmationText(e.target.value)}
              placeholder={t('type_delete')}
              variant="outlined"
              sx={{
                mb: 2 ,
                "& .MuiOutlinedInput-root.Mui-focused": {
                  "& fieldset": {
                    border: "1px solid #515151",
                  },
                },
                '& .MuiInputLabel-root': {
                  color: 'gray',
                  '&.Mui-focused': {
                    color: '#5616ea',
                  },
                },
              }}
            />
          </>
        )}
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
          <Button
            onClick={onClose}
            variant="outlined"
            sx={{
              color: '#5616ea', // text color
              borderColor: '#5616ea', // border color
              '&:hover': {
                borderColor: '#5e0fb3',
                backgroundColor: '#f3eaff', // optional hover background
              },
            }}
          >
            {t('cancel')}
          </Button>
          <Button
            onClick={handleConfirm}
            variant="contained"
            color="error"
            disabled={requireTextConfirmation && confirmationText !== "delete"}
            sx={{
              backgroundColor: '#5616ea',
              '&:hover': {
                backgroundColor: '#4a14d6',
              },
            }}
          >
            {t('remove')}
          </Button>
        </div>
      </Box>
    </Modal>
  );
};

export default ConfirmationModal;
